/**
 * @generated SignedSource<<b0626c1c43483b327da80879a6b85080>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PublishedNodesTable_Refetch$variables = {
  after?: string | null | undefined;
  filterByTitleOrDescriptionOrShortDescription?: string | null | undefined;
  first?: number | null | undefined;
};
export type PublishedNodesTable_Refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PublishedNodesTable_QueryFragment">;
};
export type PublishedNodesTable_Refetch = {
  response: PublishedNodesTable_Refetch$data;
  variables: PublishedNodesTable_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByTitleOrDescriptionOrShortDescription"
  },
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filterByTitleOrDescriptionOrShortDescription",
    "variableName": "filterByTitleOrDescriptionOrShortDescription"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "containedElementTypes",
      "storageKey": null
    }
  ],
  "type": "LearnOpportunityELearningContentTypeDefinition",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PublishedNodesTable_Refetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "PublishedNodesTable_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PublishedNodesTable_Refetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PublishedNodesAdminSchema",
            "kind": "LinkedField",
            "name": "PublishedNodes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "LearnOpportunitiesV2Connection",
                "kind": "LinkedField",
                "name": "allNodes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LearnOpportunitiesV2Edge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnOpportunityV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "typeDefinition",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LearnOpportunityV2",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "typeDefinition",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "LearnOpportunityBranchTypeDefinition",
                                "abstractKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "definitionType",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": [
                  "filterByTitleOrDescriptionOrShortDescription"
                ],
                "handle": "connection",
                "key": "PublishedNodesTable_allNodes",
                "kind": "LinkedHandle",
                "name": "allNodes"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8488dd77f1a224973254e9787a7d1e87",
    "id": null,
    "metadata": {},
    "name": "PublishedNodesTable_Refetch",
    "operationKind": "query",
    "text": "query PublishedNodesTable_Refetch(\n  $after: String\n  $filterByTitleOrDescriptionOrShortDescription: String\n  $first: Int = 10\n) {\n  ...PublishedNodesTable_QueryFragment_3xWn1f\n}\n\nfragment PublishedNodesActionColumn_NodeFragment on LearnOpportunityV2 {\n  id\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      containedElementTypes\n    }\n    ... on LearnOpportunityBranchTypeDefinition {\n      children {\n        id\n        typeDefinition {\n          __typename\n          ... on LearnOpportunityELearningContentTypeDefinition {\n            containedElementTypes\n          }\n        }\n      }\n    }\n    definitionType\n  }\n}\n\nfragment PublishedNodesTable_PublishedNodesFragment on LearnOpportunityV2 {\n  ...TitleColumnPublishedNodes_PublishedNodesFragment\n  ...PublishedNodesActionColumn_NodeFragment\n}\n\nfragment PublishedNodesTable_QueryFragment_3xWn1f on Query {\n  Admin {\n    PublishedNodes {\n      allNodes(first: $first, after: $after, filterByTitleOrDescriptionOrShortDescription: $filterByTitleOrDescriptionOrShortDescription) {\n        pageInfo {\n          endCursor\n          hasPreviousPage\n          hasNextPage\n          startCursor\n        }\n        edges {\n          node {\n            id\n            ...PublishedNodesTable_PublishedNodesFragment\n            typeDefinition {\n              __typename\n              ... on LearnOpportunityBranchTypeDefinition {\n                children {\n                  id\n                  typeDefinition {\n                    __typename\n                    ... on LearnOpportunityELearningContentTypeDefinition {\n                      containedElementTypes\n                    }\n                  }\n                }\n              }\n              definitionType\n            }\n            __typename\n          }\n          cursor\n        }\n      }\n    }\n  }\n}\n\nfragment TitleColumnPublishedNodes_PublishedNodesFragment on LearnOpportunityV2 {\n  structureDefinition {\n    __typename\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e67d6c97fba693d7326aa8bcdaf2cb1";

export default node;
